import { i18n } from "../services/i18nService";

export function getStickyLabelForCurrentLayout() {
  var currentUrl = window.location.pathname;
  currentUrl = currentUrl && currentUrl.split("/") && currentUrl.split("/")[1];
  const showStickyLabel = currentUrl && currentUrl.search(/(movies|series|kids|arabic)/) >= 0;

  if (showStickyLabel) {
    return getStickyLabelFromPath(currentUrl);
  }
}

function getStickyLabelFromPath(currentPath) {
  const LayoutToTitleMap = {
    movies: i18n.get("global.sections.movies"),
    series: i18n.get("global.sections.series"),
    arabic: i18n.get("global.sections.arabic"),
    kids: i18n.get("global.sections.kids")
  };
  if (LayoutToTitleMap[currentPath]) {
    return LayoutToTitleMap[currentPath].toUpperCase();
  } else {
    return null;
  }
}
